module.exports = __webpack_public_path__ + "static/13-39012272594a7af132ea03d7ba27bb1b.jpg";